import * as THREE from "three";

export const Tone = {
  white: 0xffffff,
  paper: 0xf4f3f0,
  bone: 0xe6e4df,
  linen: 0xd6d4ce,
  ash: 0xbcbab3,
  stone: 0x9e9c96,
  slate: 0x7d7b76,
  iron: 0x5b5955,
  bark: 0x8a8178,
  moss: 0x6d6f68,
  ink: 0x2b2825,
  void: 0x141312,
} as const;

const flatCache = new Map<number, THREE.MeshLambertMaterial>();
const smoothCache = new Map<number, THREE.MeshLambertMaterial>();

export function flat(color: number): THREE.MeshLambertMaterial {
  const cached = flatCache.get(color);
  if (cached) return cached;
  const material = new THREE.MeshLambertMaterial({
    color: new THREE.Color(color),
    flatShading: true,
  });
  flatCache.set(color, material);
  return material;
}

export function smooth(color: number): THREE.MeshLambertMaterial {
  const cached = smoothCache.get(color);
  if (cached) return cached;
  const material = new THREE.MeshLambertMaterial({ color: new THREE.Color(color) });
  smoothCache.set(color, material);
  return material;
}

export function shade(base: number, amount: number): number {
  const color = new THREE.Color(base);
  color.lerp(new THREE.Color(amount >= 0 ? 1 : 0), Math.abs(amount));
  return color.getHex();
}
